import md5 from 'js-md5'

const PWD_SECRET = process.env.VUE_APP_PWD_SECRET || ''

/**
 * 登录密码加密：MD5(PwdSecret + 明文密码) 小写 32 位 hex
 * 与后端 conf/app.ini → PwdSecret 一致
 *
 * 未配置 VUE_APP_PWD_SECRET 时：传明文，由服务端按同样规则加密后比对（API 兼容模式）
 * 输入已是 32 位 hex 时：视为密文，原样提交
 */
export function encryptLoginPassword(input) {
  const value = (input || '').trim()
  if (!value) return ''
  if (/^[a-f0-9]{32}$/i.test(value)) return value.toLowerCase()
  if (!PWD_SECRET) return value
  return md5(PWD_SECRET + value).toLowerCase()
}

/** @deprecated 使用 encryptLoginPassword */
export function hashPassword(plain) {
  return encryptLoginPassword(plain)
}

/** 新增/重置密码强度校验 */
export const PASSWORD_RULE = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9])[\x21-\x7E]{8,}$/

export function validatePasswordStrength(pwd) {
  return PASSWORD_RULE.test(pwd || '')
}

export const PASSWORD_RULE_TIP = '密码至少 8 位，须同时包含大写字母、小写字母、数字和特殊英文符号'
